/**
 * Lätt markdown-länk-renderare för Edit-chat.
 * Hanterar:
 *   - [text](url) → klickbar länk
 *   - Relativa URLs (/foo) öppnas i samma window (intern routing)
 *   - Externa URLs (https://) öppnas i ny tab
 *   - **fet** text
 *   - Övrigt: bevarar whitespace/newlines
 *
 * Bryter texten i segment och returnerar en array av React-noder.
 */
import { Fragment } from "react";

// Regex för [text](url) — fångar text & url separat
const LINK_RE = /\[([^\]]+)\]\(([^)]+)\)/g;
// Regex för **bold**
const BOLD_RE = /\*\*([^*]+)\*\*/g;

function renderInline(text, keyPrefix = "i") {
  const out = [];
  let lastIdx = 0;
  let key = 0;
  // Hitta länkar först (de har högre precedens än bold)
  let m;
  LINK_RE.lastIndex = 0;
  while ((m = LINK_RE.exec(text)) !== null) {
    if (m.index > lastIdx) {
      out.push(renderBold(text.slice(lastIdx, m.index), `${keyPrefix}-${key++}`));
    }
    const label = m[1];
    const url = m[2];
    const isExternal = /^https?:\/\//i.test(url);
    out.push(
      <a
        key={`${keyPrefix}-${key++}`}
        href={url}
        target={isExternal ? "_blank" : "_self"}
        rel={isExternal ? "noopener noreferrer" : undefined}
        className="text-[color:var(--jarvis)] underline hover:no-underline font-medium"
        data-testid="jarvis-link"
      >
        {label}
      </a>
    );
    lastIdx = m.index + m[0].length;
  }
  if (lastIdx < text.length) {
    out.push(renderBold(text.slice(lastIdx), `${keyPrefix}-${key++}`));
  }
  return out;
}

function renderBold(text, keyPrefix) {
  const parts = [];
  let lastIdx = 0;
  let key = 0;
  let m;
  BOLD_RE.lastIndex = 0;
  while ((m = BOLD_RE.exec(text)) !== null) {
    if (m.index > lastIdx) parts.push(text.slice(lastIdx, m.index));
    parts.push(
      <strong key={`${keyPrefix}-b-${key++}`} className="font-semibold">
        {m[1]}
      </strong>
    );
    lastIdx = m.index + m[0].length;
  }
  if (lastIdx < text.length) parts.push(text.slice(lastIdx));
  return <Fragment key={`${keyPrefix}-w`}>{parts}</Fragment>;
}

/**
 * Renderar Edit-text med stöd för länkar + bold.
 * Behåller \n via parent CSS (whitespace-pre-wrap).
 */
export function JarvisText({ text }) {
  if (!text) return null;
  return <>{renderInline(text, "j")}</>;
}
